    if (!customElements.get('product-form')) {
      customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
          super();
    
          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    
          this.hideErrors = this.dataset.hideErrors === 'true';
        }
    
        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    
          this.handleErrorMessage();
    
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
    
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
    
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
    
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
    
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response) });
                }, { once: true });
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }
    
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
    
          this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      });
    }
    
    class stickyCartModal extends HTMLElement {
      constructor() {
        super();
        window.addEventListener('scroll', this.update.bind(this));
        this.update();
        
        this.stickyBtn = this.querySelector('.sticky-cart-button');
        this.spinner = this.stickyBtn && this.stickyBtn.querySelector('.loading-overlay__spinner');
        this.loadingTimer = null;
        this.clearLoadingHandler = this.clearLoading.bind(this);
        
        if (this.stickyBtn) {
          this.stickyBtn.addEventListener('click', this.onClickHandler.bind(this));
          this.stickyBtn.addEventListener('keydown', this.onClickKeydownHandler.bind(this));
        }
        
        if (typeof subscribe === 'function') {
          this.cartUpdateUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, this.clearLoadingHandler);
          this.cartErrorUnsub = subscribe(PUB_SUB_EVENTS.cartError, this.clearLoadingHandler);
        }
      }
      
      update() {
        const sectionId = this.dataset.section;
        if (!sectionId) return;
        
        const button = document.getElementById(`product-form-${sectionId}`);
        if (!button) return;
        
        const addButton = button.querySelector('[name="add"]');
        if (!addButton) return;
        
        const rangeToShowModal = this.getTop(addButton) + addButton.clientHeight;
        
        if (window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')) {
          this.classList.add('show-modal');
          document.body.classList.add('modal__sticky-cart');
        }
        
        if (window.scrollY < rangeToShowModal && this.classList.contains('show-modal')) {
          this.classList.remove('show-modal');
          document.body.classList.remove('modal__sticky-cart');
        }
      }
      
      onClickKeydownHandler(event) {
        if (event.code.toUpperCase() !== 'ENTER') return false;
        this.onClickHandler();
      }
      
      onClickHandler() {
        if (this.stickyBtn && (this.stickyBtn.classList.contains('loading') || this.stickyBtn.getAttribute('aria-disabled') === 'true')) {
          return;
        }

        const sectionId = this.dataset.section;
        const productForm = sectionId && document.getElementById(`product-form-${sectionId}`);

        // Prefer to trigger the real add-to-cart action
        if (productForm) {
          const addButton = productForm.querySelector('[name="add"]');
          if (addButton) {
            this.setLoading(true);
            addButton.click();
            return;
          }

          // Fallback: submit the form if possible
          if (typeof productForm.requestSubmit === 'function') {
            this.setLoading(true);
            productForm.requestSubmit();
            return;
          }
        }

        // Ultimate fallback: scroll to the product area if we couldn't trigger add
        const item = document.getElementById("variants-container");
        const btn_item = document.getElementById("product-container");
        let _y = null;

        if (item) {
          _y = this.getTop(item);
        } else if (btn_item) {
          _y = this.getTop(btn_item);
        } else if (productForm) {
          _y = this.getTop(productForm) - 100; // Offset slightly
        }

        if (_y !== null) {
          this.scrollTo(_y, 700);
        }
      }
      
      setLoading(isLoading) {
        if (!this.stickyBtn) return;
        if (isLoading) {
          this.stickyBtn.classList.add('loading');
          this.stickyBtn.setAttribute('aria-disabled', 'true');
          if (this.spinner) this.spinner.classList.remove('hidden');
          if (this.loadingTimer) clearTimeout(this.loadingTimer);
          this.loadingTimer = setTimeout(() => this.clearLoading(), 5000);
        } else {
          this.stickyBtn.classList.remove('loading');
          this.stickyBtn.removeAttribute('aria-disabled');
          if (this.spinner) this.spinner.classList.add('hidden');
          if (this.loadingTimer) clearTimeout(this.loadingTimer);
          this.loadingTimer = null;
        }
      }

      clearLoading() {
        this.setLoading(false);
      }
      
      getTop(el) {
        return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
      }
      
      scrollTo(to, duration) {
        const element = document.scrollingElement || document.documentElement,
              start = element.scrollTop,
              change = to - start,
              startDate = +new Date();
              
        // Simple linear tweening - no animation frame loop in original code, fixing it to be smoother or just use native smooth scroll
        // Using native smooth scroll is better if supported
        
        window.scrollTo({
            top: to,
            behavior: 'smooth'
        });
      }
    }
    customElements.define('sticky-cart-modal', stickyCartModal);